import { ADD_SUPPLY_REQUEST, ADD_SUPPLY_SUCCESS, ADD_SUPPLY_ERROR, RESET_ADD_SUPPLY } from "../actions/addSupply"

let initialState = {
    loading: false,
    data: null,
    error: null
}

const addSupply = (state = initialState, action) => {
    switch (action.type) {
        case ADD_SUPPLY_REQUEST:
            return {
                ...state,
                loading: true
            }

        case ADD_SUPPLY_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case ADD_SUPPLY_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case RESET_ADD_SUPPLY:
            return {
                ...state,
                loading: false,
                data: null,
                error: null
            }
        default:
            return state;
    }
}

export default addSupply
